import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './font-face.css';
import {App} from './App'
import { IAppConfig } from './sharedInterfaces';
import { IMediaQueryConstants } from './styles/theme';


(window as any).VCThreeDConfigurator = {
  initialize: (
    config:IAppConfig,
    mount:HTMLDivElement, 
    mediaQueryConstants:IMediaQueryConstants,
    onInitialized:()=>void = () => null
  ) => {

    //COPY CONSOLE OUTPUT
    const logDiv = document.getElementById("log");
    if (logDiv) {
      const log = (string) => {
        logDiv.innerHTML += string;
        logDiv.innerHTML += '<br/>';
      };

      window.addEventListener('error', (err) => {
        log("WINDOW.ERROR: " + err.message.toString());
      });

      const handleConsoleOutput = (...args:any[]) => {
        for (let i = 0; i < args.length; i++) {
          const arg = args[i];
          if (typeof arg === 'object') {
            logDiv.innerHTML += (JSON && JSON.stringify ? JSON.stringify(arg, undefined, 2) : arg) + '<br/>';
          } else {
            logDiv.innerHTML += arg + '<br/>';
          }
        }
      };

      // console.log = (...args:any[]) => {
      //   return;
      //   logDiv.innerHTML += "CONSOLE.LOG: ";
      //   handleConsoleOutput(args);
      // };

      console.warn = (...args:any[]) => {
        logDiv.innerHTML += "CONSOLE.WARN: ";
        handleConsoleOutput(...args);
      };

      console.error = (...args:any[]) => {
        logDiv.innerHTML += "CONSOLE.ERROR: ";
        handleConsoleOutput(...args);
      };
    }
    //---

    const DEFAULT_APP_CONFIG:IAppConfig = {
      menuStyle: 'ifr',
      logoStyle: 'ifr',

      osURI: "http://qa.infinityorders.com.au",
      priceCheckURI: null,
      costPriceCheckURI: null,
      backendURI: "https://irv3.viscircle.com/test",
      assetURI: ".",
      shortLinkTarget: null,

      initialRingSKU: null,
      savedRingConfiguration: null,
      autoRotationDelay: 2500,
      autoRotationSpeed: 0.1,

      specialMode: null,
      captureConfig: null,

      noAutomaticRedirect: false,
      additionalCheckoutData: null
    }

    const DEFAULT_MEDIA_QUERY_CONSTANTS:IMediaQueryConstants = {
      desktopSmall: 920,
      phone: 811,
      phoneTiny: 400,
      lowHeight: 800,
      veryLowHeight: 700
    }

    mediaQueryConstants = Object.assign({}, DEFAULT_MEDIA_QUERY_CONSTANTS, mediaQueryConstants);
    config = Object.assign({}, DEFAULT_APP_CONFIG, config);
    
    if (!config.priceCheckURI) {
      config.priceCheckURI = `${config.osURI}/v3/api/configurator/price`;
    } else {
      console.warn("Using custom price API!", config.priceCheckURI);
    }

    //I don't remember what this is for... :(
    if (config.savedRingConfiguration && typeof config.savedRingConfiguration === "string" && config.savedRingConfiguration.includes('-')) {
      const parts = config.savedRingConfiguration.split('-');
      config.savedRingConfiguration = parts[0] + parts[2];
    }

    //We only want to invoke `${window.top.location.href.split('?')[0]}?config=[CONFIG_ID]` when actually necessary 
    if (!config.shortLinkTarget) {
      console.warn("config.shortLinkTarget not set, falling back on default value!", config);
      config.shortLinkTarget = `${window.top.location.href.split('?')[0]}?config=[CONFIG_ID]`;
    }

    ReactDOM.render(
      <App
        appConfig={{
          
          osURI: config.osURI || null,
          priceCheckURI: config.priceCheckURI || null,
          costPriceCheckURI: config.costPriceCheckURI || null,
          backendURI: config.backendURI || null,
          assetURI: config.assetURI || null,
          menuStyle: config.menuStyle || null,
          logoStyle: config.logoStyle || null,
          shortLinkTarget: config.shortLinkTarget || null,
          
          initialRingSKU: config.initialRingSKU || null,
          savedRingConfiguration: config.savedRingConfiguration || null,
          autoRotationDelay: config.autoRotationDelay || 2500,
          autoRotationSpeed: config.autoRotationSpeed || 0.1,

          specialMode: config.specialMode || null,
          captureConfig: config.captureConfig || null,

          noAutomaticRedirect: config.noAutomaticRedirect || false,
          additionalCheckoutData: config.additionalCheckoutData || null
        }}
        mediaQueryConstants={mediaQueryConstants}
        onInitialized={onInitialized}
      />, 
      mount
    )
  }
};